module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_8.fc24053a.png";